import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Column } from '../../../../components'
import Padding, { Sizes as PaddingSizes } from '../../../../components/Padding'
import { FileUtils } from '../../../../utils'
import ChannelsFilters from './ChannelsFilters'
import ContentButton from '../ContentButton'

interface ChannelsSubBarProps {
    channelsMediaSize: number;
    onOpenChannelForm: () => void;
    onRemoveChannels: () => void;
    selectedChannelsCounter: number;
}

export default function ChannelsSubBar({
    channelsMediaSize,
    onOpenChannelForm,
    onRemoveChannels,
    selectedChannelsCounter,
}: ChannelsSubBarProps) {
    return (
        <Padding top right size={PaddingSizes.xs}>
            <Padding right size={PaddingSizes.xs}>
                <Column width="50%">
                    <Padding left size={PaddingSizes.sm}>
                        <Padding bottom size={PaddingSizes.xs}>
                            {selectedChannelsCounter > 0 && channelsMediaSize > 0 &&
                                `${FileUtils.humanFileSize(channelsMediaSize)} selected`
                            }
                        </Padding>
                    </Padding>
                </Column>
                <Column right width="50%">
                    <ContentButton onClick={onOpenChannelForm}>
                        <FontAwesomeIcon icon="plus" size="1x" />
                    </ContentButton>
                    <ChannelsFilters />
                    <ContentButton
                        disabled={selectedChannelsCounter === 0}
                        onClick={() => {
                            if (selectedChannelsCounter > 0) {
                                onRemoveChannels()
                            }
                        }}
                        theme="secondaryDanger"
                    >
                        <FontAwesomeIcon icon="trash-alt" size="1x" />
                    </ContentButton>
                </Column>
            </Padding>
        </Padding>
    )
}
